import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupBankAccount } from "src/components/Shared/NewForms/NFLookupBankAccount";
import { NFLookupCashRegister } from "src/components/Shared/NewForms/NFLookupCashRegister";
import { NFLookupContract } from "src/components/Shared/NewForms/NFLookupContract";
import { NFLookupVendorCustomer } from "src/components/Shared/NewForms/NFLookupVendorCustomer";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";

const PaymentRequestOperationTypesCurrencyConversionDetail = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFLookupVendorCustomer fieldName="vendorCustomerId" title={t("VendorsAndCustomers")} />
        </Col>
        <Col sm={6}>
          <NFLookupContract fieldName="contractId" title={t("Contract")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupBankAccount fieldName="bankAccountId" title={t("BankAccount")} required />
        </Col>
        <Col sm={6}>
          <NFLookupCashRegister fieldName="cashAccountId" title={t("CashAccount")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFIntInput title={t("Amount")} fieldName={"amount"} required />
        </Col>
        <Col sm={6}>
          <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} required />
        </Col>
      </Row>
    </>
  );
};

export default PaymentRequestOperationTypesCurrencyConversionDetail;
